import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Icon = ({ classes, name, onClick, className, ...rest }) => (
  <span
    {...rest}
    className={classNames(classes.icon, className)}
    onClick={onClick}
  />
)

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  classes: PropTypes.shape({
    icon: PropTypes.string,
  }),
}

export default Icon
